import { FormattedMessage } from 'react-intl';

import { IUserWalletRewardItem } from '@share/common-types';
import { renderNumber } from '@share/utils';

import { Currency } from '../../common/currency';

import './style.scss';

interface IProps {
  allRewards: IUserWalletRewardItem[];
  currency?: string;
}

export function RewardsLifetimeValue(props: IProps) {
  const { allRewards, currency } = props;

  const totalRedeemed = allRewards
    .filter((r) => (r.status ?? '').toLowerCase() === 'redeemed' && r.rewardValue != null)
    .reduce((sum, r) => sum + (r.rewardValue ?? 0), 0);

  if (totalRedeemed <= 0) return null;

  return (
    <div className="rewards-lifetime-value">
      <span className="rewards-lifetime-value__icon">🎉</span>
      <span className="rewards-lifetime-value__text">
        <FormattedMessage
          id="rewards.lifetime.value"
          values={{
            amount: (
              <>
                <Currency currency={currency} />
                {renderNumber(totalRedeemed, 2)}
              </>
            ),
          }}
        />
      </span>
    </div>
  );
}
